import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const deleteAwardBudget = createAsyncThunk(
  "AgentTabs/deleteAwardBudget",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}api/users/v2/tabs/marketing-budget/${data?.marketing_budget_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (resp.data && data?.handleSuccess) {
        data?.handleSuccess();
      }
      return {
        ...resp.data,
        marketing_budget_id: data.marketing_budget_id,
        amount: data?.amount,
      };
    } catch (error) {
      if (error.response) {
        if (data?.handleError) {
          data?.handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (data?.handleError) {
          data?.handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
